var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIndustrial = function SvgIndustrial(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3353_13981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 17.5C4.28909 14.15 4.98575 10.8108 4.99992 7.5H9.99992C10.0141 10.8108 10.7108 14.15 11.6666 17.5",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 10.833H14.1667C14.1876 13.0097 14.9117 15.2463 15.8334 17.4997",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16678C7.68931 3.90304 7.93998 3.68934 8.23035 3.54415C8.52073 3.39896 8.84209 3.32665 9.16667 3.33345C9.49125 3.32665 9.8126 3.39896 10.103 3.54415C10.3934 3.68934 10.644 3.90304 10.8333 4.16678C11.0226 4.43052 11.2733 4.64422 11.5637 4.78941C11.8541 4.93459 12.1754 5.00691 12.5 5.00011C12.8246 5.00691 13.1459 4.93459 13.4363 4.78941C13.7267 4.64422 13.9774 4.43052 14.1667 4.16678C14.356 3.90304 14.6066 3.68934 14.897 3.54415C15.1874 3.39896 15.5088 3.32665 15.8333 3.33345C16.1579 3.32665 16.4793 3.39896 16.7696 3.54415C17.06 3.68934 17.3107 3.90304 17.5 4.16678",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5H18.3333",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3353_13981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIndustrial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "industrial.2f1f8b66d3cf0089a7e8b0b19bbd4e63.svg";